const GetUsers = 'UserManagement/GetUsers'
const GetUserRoles = 'UserManagement/GetUserRoles'
const SaveUserRoles = 'UserManagement/SaveUserRoles'
const GetAllRoles = "UserManagement/GetAllRoles"
const GetCategories = "Common/GetCategories"
const GetCategorieTypesDescription = "Common/GetCategorieTypesDescription"
const GetUsersPerDay = 'UniqueUsers/GetUsersPerDay'
const GetUserPerCountry = 'UniqueUsers/GetUserPerCountry'
const GetSessionsPerDay = 'UniqueUsers/GetSessionsPerDay'
const GetUserPerLanguage = 'UniqueUsers/GetUserPerLanguage'
const GetUsersPerAppVersion = 'UniqueUsers/GetUsersPerAppVersion'
const GetCrashesPerDay = 'Crashes/GetCrashesPerDay'
const GetCrashesPerOperatingSystem = 'Crashes/GetCrashesPerOperatingSystem'
const GetCrashesGrouped = 'Crashes/GetCrashesGrouped'
const GetCrashDetails = 'Crashes/GetCrashDetails'
const GetCrashDetailsPerDay = 'Crashes/GetCrashDetailsPerDay'
const GetEventsByUser = 'Crashes/GetEventsByUser'
const GetEventsByUserForErrorInfo = 'Crashes/GetEventsByUser'
const GetErrorsPerDay = 'Errors/GetErrorsPerDay'
const GetErrorsPerOperatingSystem = 'Errors/GetErrorsPerOperatingSystem'
const GetErrorsGrouped = 'Errors/GetErrorsGrouped'
const GetErrorDetails = 'Errors/GetErrorDetails'
const GetUniqueAppVersions = 'Common/GetUniqueAppVersions'
const GetUsersPerOperatingSystem = 'Devices/GetUsersPerOperatingSystem'
const GetUserPerManufacturer = 'Devices/GetUserPerManufacturer'
const GetUsersPerOperatingSystemVersion = 'Devices/GetUsersPerOperatingSystemVersion'
const GetUsersPerIdiom = 'Devices/GetUsersPerIdiom'
const GetPageViewsPerDay = 'PageView/GetPageViewsPerDay'
const GetPageViewsGrouped = 'PageView/GetPageViewsGrouped'
const GetFailedDependenciesPerDay = 'Dependencies/GetFailedDependenciesPerDay'
const GetTopDependencies = 'Dependencies/GetTopDependencies'
const GetDependencyAvgDurations = 'Dependencies/GetDependencyAvgDurations'
const GetFailedDependencies = 'Dependencies/GetFailedDependencies'
const GetFailedDependenciesByKey = 'Dependencies/GetFailedDependenciesByKey'
const GetEventsGrouped = 'Events/GetEventsGrouped'
const GetEventsPerDay = 'Events/GetEventsPerDay'
const GetPredefinedQueryNames = 'CustomQuery/GetPredefinedQueryNames'
const RunQuery = 'CustomQuery/RunQuery'

export const ApiUrls = {
  GetUsers,
  GetUserRoles,
  SaveUserRoles,
  GetAllRoles,
  GetCategories,
  GetCategorieTypesDescription,
  GetUsersPerDay,
  GetUserPerCountry,
  GetSessionsPerDay,
  GetUserPerLanguage,
  GetUsersPerAppVersion,
  GetCrashesPerDay,
  GetCrashesPerOperatingSystem,
  GetCrashesGrouped,
  GetCrashDetails,
  GetCrashDetailsPerDay,
  GetEventsByUser,
  GetEventsByUserForErrorInfo,
  GetErrorsPerDay,
  GetErrorsPerOperatingSystem,
  GetErrorsGrouped,
  GetErrorDetails,
  GetUniqueAppVersions,
  GetUsersPerOperatingSystem,
  GetUserPerManufacturer,
  GetUsersPerOperatingSystemVersion,
  GetUsersPerIdiom,
  GetPageViewsPerDay,
  GetPageViewsGrouped,
  GetFailedDependenciesPerDay,
  GetTopDependencies,
  GetDependencyAvgDurations,
  GetFailedDependencies,
  GetFailedDependenciesByKey,
  GetEventsGrouped,
  GetEventsPerDay,
  GetPredefinedQueryNames,
  RunQuery
}
